import { UserGender, UserProfile } from "@/generated-api";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import WomenDetailsForm from "@/components/onboarding/data-form/WomenDetailsForm";
import MenDetailsForm from "@/components/onboarding/data-form/MenDetailsForm";
import { useTranslation } from "@/hooks/useTranslation";

export default function UserDetailsForm({
  user,
  onSaveSuccess,
}: {
  user: UserProfile;
  onSaveSuccess?: () => void;
}) {
  const t = useTranslation();

  return (
    <Card className="dark px-2 max-w-2xl w-full">
      <CardHeader className="space-y-4 px-4 sm:px-6">
        <CardTitle>{t.USER_FORM.LABELS.TITLE}</CardTitle>
      </CardHeader>
      <CardContent className="px-4 sm:px-6">
        {user.gender === UserGender.MALE ? (
          <MenDetailsForm
            user={user}
            useSave={true}
            onSaveSuccess={onSaveSuccess}
          />
        ) : (
          <WomenDetailsForm
            user={user}
            useSave={true}
            onSaveSuccess={onSaveSuccess}
          />
        )}
      </CardContent>
    </Card>
  );
}
